import styled, { css } from 'styled-components';

import Doppler from 'components/Doppler';
import { KeyboardDatePicker } from '@material-ui/pickers';
import DateRangePicker from '../DateRangePicker';

export default {
  DatePickerWrapper: styled(Doppler)`
    width: 100%;
    margin-top: 10px;

    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        max-width: 320px;
        align-self: flex-end;
      }
      ${theme.breakpoints.up('md')} {
        padding: 30px 12px 20px;
        align-self: unset;
        max-width: initial;
        border: 1px solid ${theme.palette.action.disabledBackground};
      }
      ${theme.breakpoints.up('lg')} {
        padding: 30px 30px 20px;
      }
    `}

    & .MuiFormLabel-root {
      text-transform: none;
    }
  `,

  DatePickerInputs: styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    input {
      height: 42px;
    }

    & .MuiInputAdornment-positionEnd {
      margin-left: 0;
    }

    ${({ theme }) => css`
      ${theme.breakpoints.up('md')} {
        flex-direction: row;
        margin-bottom: 10px;
      }
    `}
  `,

  DatePickerDivider: styled.div`
    position: relative;
    top: 14px;
    padding: 0 8px;
    color: #616161;

    ${({ theme }) => css`
      display: none;
      font: 700 0.75rem ${theme.typography.fontFamilyAccent};

      ${theme.breakpoints.up('md')} {
        display: block;
        padding: 0 20px;
      }
    `}
  `,

  DateRangePicker: styled(DateRangePicker)`
    padding: 0;
    width: 100%;

    & .MuiPickersStaticWrapper-staticWrapperRoot {
      flex: 1;
    }

    & .MuiDateRangePicker-divider {
      margin: 0 4%;
      ${({ theme }) => css`
        ${theme.breakpoints.up('md')} {
          margin: 0 2.5%;
        }
        ${theme.breakpoints.up('lg')} {
          margin: 0 30px;
        }
      `}
    }

    & .MuiPickersCalendarHeader-switchHeader {
      margin-left: -16px;
      margin-right: -16px;

      ${({ theme }) => css`
        ${theme.breakpoints.up('md')} {
          margin-left: 0;
          margin-right: 0;
        }
      `}
    }
  `,

  KeyboardDatePicker: styled(KeyboardDatePicker)`
    width: 100%;
    margin: 0 0 10px;

    ${({ theme }) => css`
      ${theme.breakpoints.up('md')} {
        margin-bottom: 0;
      }
    `}

    & .MuiInputLabel-outlined {
      transform: translate(20px, 11px) scale(1);

      &.Mui-focused,
      &.MuiFormLabel-filled {
        transform: translate(20px, 14px) scale(0.75);
      }
    }

    & .MuiOutlinedInput-root {
      border-radius: 4px;
      padding-right: 0;
    }

    & .MuiInputBase-input.MuiOutlinedInput-input {
      padding: 7px 20px 11px;
      text-align: right;
      font-size: 16px;
      color: #616161;

      ${({ theme }) => css`
        &:focus {
          color: ${theme.palette.background.dark.main};
        }

        ${theme.breakpoints.up('md')} {
          padding-right: 10px;
          padding-left: 10px;
          font-size: 24px;
          text-align: center;
        }
      `}
    }

    &.field-error .MuiOutlinedInput-notchedOutline {
      ${({ theme }) => css`
        border-color: ${theme.palette.error.main};
      `}
    }
  `,
};
